import React from "react";
import styles from './mediatext.module.scss';
import { KoText } from "packages/typography";
import KoImage from "packages/image";
import KoButton from "packages/button";
import KoIcon from "@kwapio/icons";

function KoMediaText(props) {
  const { data, row, onExtraClick } = props;

  return (
    <div className={styles.priorityWrapper}>
      <div className={styles.priority}>
        <div className={styles.priorityStatus}>
          <div className={styles.image}>
            <KoImage width={28} height={28} src={row.media}/>
          </div>
          <KoText text={data} className={styles.link}/>
          {!row?.subTask &&
            <KoButton onClick={() => onExtraClick && onExtraClick(row)}
              className={styles.btn} iconBtn={true} type={'text'}
              icon={<KoIcon className={styles.icon} name={'TreeOutlined'} width={14} height={14} />}/>
          }
        </div>
      </div>
    </div>
  );
}

export default KoMediaText;
